import { isRedoEmployeeEmail } from "@redotech/account-common/redo-employee";
import { ManagedUserRoles } from "@redotech/account-common/roles";
import type { GetUser } from "@redotech/account-common/user";
import { isWmsRoute } from "../../app/wms-route";

/**
 * TEMPORARY: these accounts see the offer on any store, so the team can review
 * it in place. Remove once the modal has been signed off.
 */
const CREDIT_INCENTIVE_REVIEWER_EMAILS: ReadonlySet<string> = new Set([
  "dev@getredo.com",
]);

function isReviewer(email: string | null | undefined): boolean {
  return (
    email != null &&
    CREDIT_INCENTIVE_REVIEWER_EMAILS.has(email.trim().toLowerCase())
  );
}

export interface CreditIncentiveTeam {
  settings: {
    shopifyExtension?: {
      coverageCreditIncentive?: { enabled?: boolean | null } | null;
    } | null;
  };
}

export type CreditIncentiveUser = Pick<GetUser, "email" | "managedUserRoles">;

/** A store already running the incentive has nothing left to set up. */
function usesCreditIncentive(team: CreditIncentiveTeam): boolean {
  return (
    team.settings.shopifyExtension?.coverageCreditIncentive?.enabled === true
  );
}

/**
 * Every admin of a store not yet using the incentive, whether or not it sells
 * coverage. Day-to-day staff, warehouse users above all, never see an offer.
 */
export function isEligibleForCreditIncentive(
  team: CreditIncentiveTeam,
  user: CreditIncentiveUser | undefined,
  pathname: string,
): boolean {
  if (isWmsRoute(pathname)) {
    return false;
  }
  if (isReviewer(user?.email)) {
    return true;
  }
  if (!user?.managedUserRoles?.includes(ManagedUserRoles.ADMIN)) {
    return false;
  }
  if (isRedoEmployeeEmail(user.email)) {
    return false;
  }
  return !usesCreditIncentive(team);
}
